import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { AlertaProductoRechazadoWrapperComponent } from './alertasProductosRechazados/alertaProductoRechazado-wrapper/alertaProductoRechazado-wrapper.component';
import { AlertaProductoRechazadoExWrapperComponent } from './alertasProductosRechazadosEx/alertaProductoRechazadoEx-wrapper/alertaProductoRechazadoEx-wrapper.component';
import { AlertaMatriculaRechazadaWrapperComponent } from './alertasMatriculasRechazadas/alertaMatriculaRechazada-wrapper/alertaMatriculaRechazada-wrapper.component';

const alertasRoutes: Routes = [
    // Alerta Producto Rechazado
    {
        path: 'mantenimiento/alertas/alertaproductorechazado',
        data: {
            breadcrumb: 'Alertas de Productos Rechazados Importación',
            menu0: 'MANTENIMIENTO',
            menu1: 'Alertas',
        },
        children: [
            {
                path: '',
                component: AlertaProductoRechazadoWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    // Alerta Matrícula Rechazada
    {
        path: 'mantenimiento/alertas/alertamatricularechazada',
        data: {
            breadcrumb: 'Alertas de Matrículas Rechazadas Importación',
            menu0: 'MANTENIMIENTO',
            menu1: 'Alertas',
        },
        children: [
            {
                path: '',
                component: AlertaMatriculaRechazadaWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    // Alerta Producto Rechazado Exportación
    {
        path: 'mantenimiento/alertas/alertaproductorechazadoex',
        data: {
            breadcrumb: 'Alertas de Productos Rechazados Exportación',
            menu0: 'MANTENIMIENTO',
            menu1: 'Alertas',
        },
        children: [
            {
                path: '',
                component: AlertaProductoRechazadoExWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(alertasRoutes)],
    exports: [RouterModule],
})
export class AlertasRoutingModule {}
